import { render, staticRenderFns } from "./SimplePaymentTypeSelect.vue?vue&type=template&id=5cf78eea&"
import script from "./SimplePaymentTypeSelect.vue?vue&type=script&lang=js&"
export * from "./SimplePaymentTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./SimplePaymentTypeSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports